import Icon from "@material-ui/core/Icon"
import { FC } from "react"
import { btnEvent } from "./Button"

interface IDoubleButton {
  onClick: (event: btnEvent) => void
  editMode: string
  btnText: string
}

interface DoubleButtonProps {
  buttons: IDoubleButton[]
  icon: string
  doubleIcon?: string
  title: string
  type?: "submit" | "reset" | "button"
}

const DoubleButton: FC<DoubleButtonProps> = ({
  type,
  icon,
  title,
  buttons,
  doubleIcon
}) => {
  return (
    <div className="ocs-double-btn d-flex flex-column align-items-center">
      <span className="d-flex align-items-center ocs-mb-4">
        <Icon className="ocs-md-btn-icon">{icon} </Icon>
        {doubleIcon && <span className="ocs-mr-8">+</span>}
        {doubleIcon && <Icon className="ocs-md-btn-icon">{doubleIcon} </Icon>}
        <p>{title}</p>
      </span>
      <span className="d-flex">
        <button
          className={`ocs-btn flex-column`}
          onClick={buttons[0].onClick}
          type={type}
        >
          <span className="ocs-mb-4">{buttons[0].editMode}</span>
          <span>{buttons[0].btnText}</span>
        </button>
        <button
          className={`ocs-btn flex-column`}
          onClick={buttons[1].onClick}
          type={type}
        >
          <span className="ocs-mb-4">{buttons[1].editMode}</span>
          <span>{buttons[1].btnText}</span>
        </button>
      </span>
    </div>
  )
}

export default DoubleButton
